import { CancelTokenSource } from 'axios';
import {
  CovidTestRegistrationData,
  InterventionOrderItemResultDto,
  PraxTestRegistrationQrCodeRequest,
  TestPanelTestkitRegistrationRequestDto,
  TestRegistrationCreationResponse,
  TestResultUpdateResponseDto
} from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/testkit`;

export const getCovidTestRegistrationData = (
    token: string, source: CancelTokenSource): Promise<CovidTestRegistrationData> => {
  return axios
      .get(`${baseUrl}/public/api/testkit/covid-test-data`, {params: {token}, cancelToken: source.token})
      .then(response => response.data);
};

export const getPublicOrderItemResult = (
    token: string,
    cancelSourceToken: CancelTokenSource): Promise<InterventionOrderItemResultDto> => {

  return axios
      .get(`${baseUrl}/public/api/testkit/order-item-result`, {
        params: {token},
        cancelToken: cancelSourceToken.token
      })
      .then(response => response.data);
}

export const createCovidTestkitQrcodeBase64String = (
    request: PraxTestRegistrationQrCodeRequest,
    source: CancelTokenSource): Promise<TestRegistrationCreationResponse> => {

  return axios
      .post(`${apiUri}/covid-test/qrcode`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const createPanelTestkitQrcodeBase64String = (
    request: PraxTestRegistrationQrCodeRequest,
    source: CancelTokenSource): Promise<TestRegistrationCreationResponse> => {

  return axios
      .post(`${apiUri}/panel-test/qrcode`, request, {cancelToken: source.token})
      .then(response => response.data);
};

export const registerCovidTestkitResult = (
    token: string,
    testResult: string,
    file: any,
    interventionExternalCode: string,
    ctValue: string | undefined,
    source: CancelTokenSource): Promise<TestResultUpdateResponseDto> => {

  const formData = new FormData();
  formData.append("file", file);
  formData.append("token", token);
  formData.append("testResult", testResult);
  formData.append("interventionExternalCode", interventionExternalCode);

  if (ctValue) {
    formData.append("ctValue", ctValue);
  }

  return axios
      .post(`${baseUrl}/public/api/testkit/register-covid-test`, formData, {cancelToken: source.token})
      .then(response => response.data);
};

export const registerTestPanelTestkitResult = (
    requestDto: TestPanelTestkitRegistrationRequestDto,
    file: any,
    source: CancelTokenSource): Promise<TestResultUpdateResponseDto> => {

  const requestJsonString = JSON.stringify(requestDto);
  const blob = new Blob([requestJsonString], {
    type: 'application/json'
  });

  const formData = new FormData();
  formData.append("requestDto", blob);
  formData.append("file", file);

  return axios
      .post(`${baseUrl}/public/api/testkit/register-panel-test`,
          formData,
          {cancelToken: source.token})
      .then(response => response.data);
}
